import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dimmed"];
import React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { spacing, breakpoints } from 'styles/globals';
import { swing } from 'styles/animations';
var Wrapper = styled.div.withConfig({
  displayName: "Spinner__Wrapper",
  componentId: "sc-13nar4j-0"
})(["position:relative;display:inline-block;margin:0 auto;padding-top:", ";padding-bottom:", ";font-size:", ";", " @media (min-width:", "){font-size:", ";}@media (min-width:", "){font-size:", ";}"], spacing.s, spacing.s, pxToRem(6), function (p) {
  return p.dimmed && "\n\t\topacity: 0.5;\n\t";
}, breakpoints.s, pxToRem(8), breakpoints.m, pxToRem(10));
var Dot = styled.div.withConfig({
  displayName: "Spinner__Dot",
  componentId: "sc-13nar4j-1"
})(["display:inline-block;width:1em;height:1em;color:inherit;background-color:currentColor;border-radius:10rem;font-size:inherit;animation:", " 0.4s infinite linear alternate;& + &{margin-left:0.5em;}&:nth-child(2){animation-delay:-0.1s;}&:nth-child(3){animation-delay:-0.2s;}"], swing);
var Spinner = function Spinner(_ref) {
  var _ref$dimmed = _ref.dimmed,
    dimmed = _ref$dimmed === void 0 ? false : _ref$dimmed,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, otherProps, {
    dimmed: dimmed
  }), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null));
};
export default Spinner;